module.exports = __webpack_public_path__ + "img/site.00c8f04d.svg";